module.exports = __webpack_public_path__ + "assets/e6305f2abc08659a33456bd82e31ba1d.png";